import React from 'react';
import ReactDOM from 'react-dom';
import { Controller } from '@hotwired/stimulus';

import { SurveyPreview } from '@/components/organisms/SurveyPreview';

export default class extends Controller {
  // @ts-ignore
  declare schemaValue;

  // @ts-ignore
  declare uiSchemaValue;

  static values = {
    schema: Object,
    uiSchema: Object,
  };

  static targets = ['schema', 'uiSchema', 'canvas'];

  connect() {
    // schemaValue change keys input1, input2, etc. to 設問1, 設問2, etc.
    const schema = this.schemaValue;
    const newKeysMap = Object.fromEntries(
      Object.entries(schema.properties).map(([key, value]) => {
        const newKey = value.title.replace(/\s+/g, '');
        return [key, newKey];
      })
    );
    const newProperties = Object.fromEntries(
      Object.entries(schema.properties).map(([key, value]) => {
        const newKey = newKeysMap[key];
        return [newKey, value];
      })
    );
    const newRequired = schema.required.map((key) => newKeysMap[key]);
    this.schemaValue = {
      ...schema,
      properties: newProperties,
      required: newRequired
    };
    // End schemaValue

    // uiSchemaValue change keys input1, input2, etc. to 設問1, 設問2, etc.
    const keyMap = {
      input1: "設問1",
      input2: "設問2",
      input3: "設問3",
      input4: "設問4",
      input5: "設問5"
    };
    const newUiSchemaValue = {};
    for (const key in this.uiSchemaValue) {
      if (key === "ui:order") {
        newUiSchemaValue[key] = this.uiSchemaValue[key].map(k => keyMap[k] || k);
      } else {
        newUiSchemaValue[keyMap[key] || key] = this.uiSchemaValue[key];
      }
    }
    this.uiSchemaValue = newUiSchemaValue;
    // End uiSchemaValue

    ReactDOM.render(
      Object.keys(this.uiSchemaValue).length ? (
        <SurveyPreview
          schema={this.schemaValue}
          uiSchema={this.uiSchemaValue}
        />
      ) : <div className="alert alert-danger"><p>設問を設定してください。</p></div>,
      this.canvas,
    );
  }

  disconnect() {
    ReactDOM.unmountComponentAtNode(this.canvas);
  }

  get canvas() {
    return this.targets.find('canvas') as HTMLElement;
  }
}
